export enum MicrositeAction {
    EditRegistration = 1,
    EditProfile = 2,
    PatientsProfile = 3,
    ViewStarterSite = 4,
    ViewCurrentlyActiveCustomSite = 5,
    PreviewCustomSite = 6,
    Approve = 7,
    Decline = 8,
    ModifyCustomSite = 10,
    ViewRegistrations = 11,
    ViewCompletedRegistrations = 12,
    SendReminderEmail = 14,
    ResendApprovalEmail = 15,
    Confirm = 16,
    Deny = 17,
    DownloadCardBatchFile = 18,
    ViewActivityLog = 21,
    ViewLinkedEntities = 22,
    ChangeStatus = 23,
    ViewRegistrationsNoCenter = 24,
    ViewCompletedRegistrationsNoCenter = 25,
    EditDemographic = 26
}